<template>
  <main>
    <site-nav />
    <hero :heading="entry.hero.heading" :subheading="entry.hero.subheading" :images="entry.heroImages" position="center" readMore />
    <div class="c-section" v-if="entry && entry.featuredProjects">
      <div class="o-wrapper">
        <div class="c-section__header">
          <h3 class="c-section__heading u-600">Featured Projects</h3>
          <router-link class="c-btn c-btn--quaternary" :to="{ name: 'projects'}">View all projects</router-link>
        </div>
        <ul class="o-layout o-layout--stretch">
          <li class="o-layout__item u-1/3@tablet u-mb u-mb0@desktop" v-for="entry in entry.featuredProjects" :key="entry.id">
            <project-card :entry="entry" />
          </li>
        </ul>
      </div>
    </div>
    <banner />
    <div class="c-section" v-if="entry && entry.featuredNews">
      <div class="o-wrapper">
        <div class="c-section__header">
          <h3 class="c-section__heading u-600">Featured News</h3>
          <router-link class="c-btn c-btn--quaternary" :to="{ name: 'news'}">View all news</router-link>
        </div>
        <ul class="o-layout o-layout--stretch o-layout--lined o-layout--large">
          <li class="o-layout__item u-1/3@tablet u-mb+" v-for="entry in entry.featuredNews" :key="entry.id">
            <article-card :entry="entry" />
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import axios from 'axios'
import Hero from '@/components/Hero.vue'
import Banner from '@/components/Banner.vue'
import ProjectCard from '@/components/ProjectCard.vue'
import SiteNav from '@/components/SiteNav.vue'
import ArticleCard from '@/components/ArticleCard.vue'

export default {
  name: 'Home',
  metaInfo () {
    return {
      title: this.title
    }
  },
  components: {
    Hero: Hero,
    Banner: Banner,
    ProjectCard: ProjectCard,
    ArticleCard: ArticleCard,
    SiteNav: SiteNav
  },
  data () {
    return {
      title: '',
      entry: null
    }
  },
  mounted () {
    this.getEntry()
  },
  methods: {
    getEntry () {
      axios
        .get('api/home.json')
        .then(response => {
          this.entry = response.data
          this.title = this.entry.title
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue